import React from 'react'
import { connect } from 'react-redux'
import * as selectors from 'selectors'
import About from 'components/About'
import Dashboard from 'components/Dashboard'
import { scaleOrdinal, schemeCategory20c } from 'd3-scale'
import loadUserAndFetchFunds from 'utils/loadUserAndFetchFunds'
import compose from 'recompose/compose'

export const colors = scaleOrdinal().range(schemeCategory20c)

class Home extends React.Component {
  render() {
    const { funds } = this.props
    if (funds.length === 0) {
      return <About {...this.props} />
    } else {
      return <Dashboard {...this.props} />
    }
  }
}

const mapStateToProps = state => ({
  funds: selectors.fundsWithValueMergedByCrypto(state),
})

export default compose(connect(mapStateToProps, null), loadUserAndFetchFunds)(
  Home
)



// WEBPACK FOOTER //
// ./src/components/Home.js